export default "__VITE_ASSET__BSILFXjm__"